module.exports = __webpack_public_path__ + "media/images/tick-5da885a63923747d3062ea1797b1fdfb.png";